// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","brandComparison":"brandComparision_brandComparison__ynx28"};